export default __webpack_public_path__ + "static/media/interact-module.d9fa56ea.svg";